export const ApiV2ClientName = 'apiV2';

export const apolloContextWithApiV2ClientName = {
  clientName: ApiV2ClientName,
};
